import React from 'react';
import TeacherTable from './TeacherTable';

const TeacherShow = () => {
  return <TeacherTable />;
};

export default TeacherShow;
